import { getJson } from "../../../api/http";

var test_mode = true;
const API_BASE = (process.env.REACT_APP_DB_MANAGEMENT_API?? "").replace(/\/+$/, "");

function build(path: string) {
    return path.startsWith("http") ? path : `${API_BASE}${path.startsWith("/") ? "" : "/"}${path}`;
}

export function callDatabaseCopyAPI(signal?: AbortSignal): Promise<string> {
    if (test_mode == false)
        return getJson<string>(build("/api/CopyDatabase"), { signal });
    else
        return Promise.resolve("Database Copy Started...")
}